import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
// import download from 'downloadjs';
import jsPDF from 'jspdf';
import JsBarcode from 'jsbarcode';

const MAX_DROPDOWN_OPTIONS = 100;
const MAX_VISIBLE_CHIPS = 100;
const PRINT_CHUNK_SIZE = 25;
const MAX_ITEMS_PER_PDF = 1000;

export default {
	name: 'barcode',
	components: {
		Multiselect,
		VueElementLoading,
		// download,
	},
	props: [],
	data() {
		return {
			hubid:'',
			binpalletno:'',
			binPalletLoading:'',
			isLoadingSearch:false,
			checkAllBins: false,
			binPalletSearchQuery: '',
			searchTimeoutHandler: null,
			binDetails:[],
			selectedBinPallets: [],
      createdby:'',
			selected: '',
      options: [
        { text: 'Bin Search', value: 'bin' },
        { text: 'Pallet Search', value: 'pallet' },
        { text: 'Pigeon Hole Search', value: 'pigeonhole' }
      ],
		}
	},
	computed: {
		allBinsLabel() {
			return this.selected === 'bin' ? 'ALL Bins' : this.selected === 'pallet' ? 'ALL Pallets' : 'ALL Pigeon Holes';
		},
		selectionSummaryLabel() {
			if (!this.checkAllBins) {
				return null;
			}
			if (this.binDetails.length > 0) {
				return `${this.allBinsLabel} (${this.binDetails.length})`;
			}
			return this.allBinsLabel;
		},
		filteredBinDetails() {
			const query = (this.binPalletSearchQuery || '').trim().toLowerCase();
			if (!query) {
				return this.binDetails;
			}
			return this.binDetails.filter(item => item.text.toLowerCase().includes(query));
		},
		dropdownBinDetails() {
			return this.filteredBinDetails.slice(0, MAX_DROPDOWN_OPTIONS);
		},
		dropdownOptionsTruncated() {
			return this.filteredBinDetails.length > MAX_DROPDOWN_OPTIONS;
		},
		dropdownTotalCount() {
			return this.filteredBinDetails.length;
		},
		hasActiveBinPalletSearch() {
			return (this.binPalletSearchQuery || '').trim().length > 0;
		},
		searchActionItems() {
			return this.hasActiveBinPalletSearch
				? this.filteredBinDetails
				: this.binDetails;
		},
		searchActionCount() {
			return this.searchActionItems.length;
		},
		displayedSelectedChips() {
			return this.selectedBinPallets.slice(0, MAX_VISIBLE_CHIPS);
		},
		remainingSelectedChipCount() {
			return Math.max(0, this.selectedBinPallets.length - MAX_VISIBLE_CHIPS);
		},
		hasBinPalletSelection() {
			return this.checkAllBins || this.selectedBinPallets.length > 0;
		},
		selectedBinPalletValueSet() {
			return new Set(this.selectedBinPallets.map(item => this.normalizeBinPalletValue(item.value)));
		},
	},
	filters: {
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.getBinPalletList();
	},
	beforeDestroy() {
		this.clearBinPalletSearchTimeout();
	},
	methods: {

		clearBinPalletSearchTimeout() {
			if (this.searchTimeoutHandler) {
				clearTimeout(this.searchTimeoutHandler);
				this.searchTimeoutHandler = null;
			}
		},

		clearMultiselectSearch() {
			this.binPalletSearchQuery = '';
		},

		clearSelectionState() {
			this.selectedBinPallets = [];
			this.checkAllBins = false;
		},

		getItemsToPrint() {
			if (this.checkAllBins) {
				return this.binDetails.slice();
			}
			return this.selectedBinPallets.slice();
		},

		getBinPalletList() {
			if(!this.selected) return false;

			this.clearBinPalletSearchTimeout();
			this.binDetails = [];
			this.clearSelectionState();
			this.clearMultiselectSearch();

			this.binPalletLoading = 'Searching Bin/ Pallet/ Pigeon Hole...'
			this.input = ({});

			axios({
				method: 'GET',
				url: apiUrl.api_url_hubops + 'getAllBinPalletList?currentHubId=' + this.hubid + '&type=' + this.selected,
				data: this.input,
				headers: {
					'Authorization': 'authkey xB84JJ89Hd25'
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.binDetails = [];
					var binDet = result.data.ResponseData
					for (var i = 0; i < binDet.length; i++) {
						const rawValue = (this.selected == 'bin' || this.selected == 'pigeonhole') ? binDet[i].binid : binDet[i].containerid;
						if (rawValue == null || rawValue === '') {
							continue;
						}
						this.binDetails.push({
							"text": (this.selected == 'bin' || this.selected == 'pigeonhole') ? binDet[i].binnumber : binDet[i].containernumber,
							"value": this.normalizeBinPalletValue(rawValue),
						});
					}
				} else {
					this.$alertify.error(result.data.ReturnMessage)
				}
				this.binPalletLoading = '';
			}, error => {
				this.binPalletLoading='';
				console.error(error)
			})
		},

		resetForm(){
		 this.clearBinPalletSearchTimeout();
		 this.binpalletno = '';
		 this.clearSelectionState();
		 this.clearMultiselectSearch();
		 this.isLoadingSearch = false;
		 this.$validator.reset();
	 },

	 onBinPalletSearchChange(query) {
		 this.clearBinPalletSearchTimeout();
		 this.searchTimeoutHandler = setTimeout(() => {
			 this.binPalletSearchQuery = (query || '').trim();
			 this.searchTimeoutHandler = null;
		 }, 250);
	 },

	 onBinPalletOptionClick(option) {
		 if (this.checkAllBins) {
			 return;
		 }

		 const ms = this.$refs.binPalletMultiselect;
		 if (ms) {
			 if (this.isBinPalletSelected(option)) {
				 ms.remove(option);
			 } else {
				 ms.select(option);
			 }
		 }
	 },

	 normalizeBinPalletValue(value) {
		 return String(value);
	 },

	 isBinPalletSelected(option) {
		 if (this.checkAllBins) {
			 return true;
		 }
		 return this.selectedBinPalletValueSet.has(this.normalizeBinPalletValue(option.value));
	 },

	 clearAllBinPalletSelection() {
	 	 this.clearSelectionState();
	 },

	 removeSelectedBinPallet(option) {
	 	 const ms = this.$refs.binPalletMultiselect;
	 	 if (ms && typeof ms.remove === 'function') {
	 	 	 ms.remove(option);
	 	 	 return;
	 	 }
	 	 this.selectedBinPallets = this.selectedBinPallets.filter(
	 	 	 item => this.normalizeBinPalletValue(item.value) !== this.normalizeBinPalletValue(option.value)
	 	 );
	 	 this.syncCheckAllState();
	 },

	 toggleCheckAllBins() {
	 	 if (this.binDetails.length === 0) {
	 	 	 return;
	 	 }
	 	 if (this.checkAllBins) {
	 	 	 this.clearAllBinPalletSelection();
	 	 	 return;
	 	 }
	 	 if (this.selectedBinPallets.length === this.binDetails.length) {
	 	 	 this.clearAllBinPalletSelection();
	 	 	 return;
	 	 }
	 	 this.checkAllBins = true;
	 	 this.selectedBinPallets = [];
	 },

	 selectAllFromSearch() {
	 	 if (this.checkAllBins) {
	 	 	 return;
	 	 }

	 	 const items = this.searchActionItems;
	 	 if (items.length === 0) {
	 	 	 return;
	 	 }

	 	 if (!this.hasActiveBinPalletSearch || items.length === this.binDetails.length) {
	 	 	 if (this.binDetails.length === 0) {
	 	 	 	 return;
	 	 	 }
	 	 	 this.checkAllBins = true;
	 	 	 this.selectedBinPallets = [];
	 	 	 return;
	 	 }

	 	 const selectedSet = this.selectedBinPalletValueSet;
	 	 const toAdd = items.filter(item => !selectedSet.has(this.normalizeBinPalletValue(item.value)));
	 	 if (toAdd.length > 0) {
	 	 	 this.selectedBinPallets = this.selectedBinPallets.concat(toAdd);
	 	 }
	 	 this.syncCheckAllState();
	 },

	 deselectAllFromSearch() {
	 	 if (!this.hasActiveBinPalletSearch || this.checkAllBins) {
	 	 	 return;
	 	 }

	 	 const filteredValueSet = new Set(this.filteredBinDetails.map(item => this.normalizeBinPalletValue(item.value)));
	 	 this.selectedBinPallets = this.selectedBinPallets.filter(
	 	 	 item => !filteredValueSet.has(this.normalizeBinPalletValue(item.value))
	 	 );
	 	 this.syncCheckAllState();
	 },

	 syncCheckAllState() {
	 	 if (this.checkAllBins) {
	 	 	 return;
	 	 }
	 	 const total = this.binDetails.length;
	 	 if (total === 0 || this.selectedBinPallets.length !== total) {
	 	 	 return;
	 	 }
	 	 this.checkAllBins = true;
	 	 this.selectedBinPallets = [];
	 },

	 yieldToBrowser() {
		 return new Promise(resolve => setTimeout(resolve, 0));
	 },

	 async bulkAction(){
		if (!this.hasBinPalletSelection) {
			this.$alertify.error('Select atleast one bin/ pallet number!');
			return false;
		}

		const items = this.getItemsToPrint();
		if (items.length === 0) {
			this.$alertify.error('No bins/pallets available to print. Please reload the list and try again.');
			return false;
		}

		this.isLoadingSearch = true;

		try {
			const totalBatches = Math.ceil(items.length / MAX_ITEMS_PER_PDF);
			if (totalBatches > 1) {
				this.$alertify.warning('Large selection detected. Printing in batches to avoid browser memory errors.');
			}

			for (let start = 0; start < items.length; start += MAX_ITEMS_PER_PDF) {
				const batch = items.slice(start, start + MAX_ITEMS_PER_PDF);
				const doc = new jsPDF('p', 'pt', 'a4');
				doc.setFontSize(115).setFontType("bold")
				doc.setLineWidth(.5)

				let o = 0;
				let e = 0;

				for (let i = 0; i < batch.length; i++) {
					const index = start + i;
					const barcUrl = await this.textToBase64Barcode(batch[i].text);

					if (index > 0 && o == 3 && e == 3) {
						o = 0;
						e = 0;
						doc.addPage();
					}

					if (index % 2 == 0) {
						doc.rect(32, (65 + o * 260), 216, 200)
						doc.addImage(barcUrl, 'JPEG', 55, (125 + o * 260), 168, 70)
						o++;
					} else {
						doc.rect(334, (65 + e * 260), 216, 200)
						doc.addImage(barcUrl, 'JPEG', 357, (125 + e * 260), 168, 70)
						e++;
					}

					if (i > 0 && i % PRINT_CHUNK_SIZE === 0) {
						await this.yieldToBrowser();
					}
				}

				doc.save(`sticker_${start + 1}.pdf`);
				await this.yieldToBrowser();
			}

			this.isLoadingSearch = false;
		} catch (error) {
			this.isLoadingSearch = false;
			console.log('errors exist', error)
		}
	 },

	 async textToBase64Barcode(text){
		var canvas = document.createElement("canvas");
		JsBarcode(canvas, String(text), {
			format: 'CODE39',
			displayValue: true,
			width: 1.2,
			height: 60,
			margin: 5,
			fontSize: 18,
			fontoptions: 'bold',
			background: '#ffffff',
			lineColor: '#000000'
		});
		return canvas.toDataURL('image/jpeg', 0.9);
	 },
	}
}



// WEBPACK FOOTER //
// ./src/views/components/Palletization/Barcode/Barcode.js